const styles = theme => ({
  root: {
    backgroundColor: "#EFF6EE"
  },
  tavbarContainer: {
    paddingLeft: theme.spacing(4),
    backgroundColor: "#EFF6EE",
    [theme.breakpoints.down("md")]: {
      display: "none"
    }
  },
  headerBar: {
    minHeight: 80
  },
  appBarContainer: {
    backgroundColor: "#EFF6EE",
    padding: 4
  },

  appBarText: {
    marginRight: "50px",
    height: 19,
    fontSize: 16,
    fontFamily: "Roboto",
    letterSpacing: 0,
    textTransform: "uppercase",
    fontWeight: "bold"
  },
  superAdminContainer: {
    marginRight: theme.spacing(6),
    textDecoration: "none"
  },
  superAdminTitle: {
    color: theme.palette.primary.default
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/TabBar/styles.js